import { Tooltip } from 'antd';

import { stageValue } from './PipelineFlow';
import { STOCK_ROW_LABELS } from '../locations';
import type { PipelineStage } from '../../../types/dashboard';

/** Стадії, які НЕ входять у підсумок «сира + суха деревина». */
const EXCLUDED_FROM_TOTAL = new Set(['blank_stock', 'product_stock']);

const TOTAL_HINT =
  'Цей рядок рахує всі дошки, сирі та сухі — крім обсягу деревини, ' +
  'що вже перероблена в чорнові заготовки.';

export function StocksWidget({ pipeline }: { pipeline: PipelineStage[] }) {
  const rows = pipeline.filter((s) => s.metric_unit === 'м³');
  // Підсумок рахуємо з ТИХ САМИХ округлених чисел, що показані в стовпчику,
  // інакше рядки не сходяться з підсумком на десяту.
  const total = rows
    .filter((s) => !EXCLUDED_FROM_TOTAL.has(s.key))
    .reduce((acc, s) => acc + Math.round(parseFloat(s.metric_value) * 10) / 10, 0);

  return (
    <div className="dash-card" style={{ display: 'flex', flexDirection: 'column' }}>
      <div className="dash-section-label" style={{ marginBottom: 12 }}>
        Залишки по складах, м³
      </div>

      <div className="dash-stocks">
        {rows.map((s) => (
          <div key={s.key} className="dash-stock-row">
            <span className="dash-stock-name">{STOCK_ROW_LABELS[s.key] ?? s.title}</span>
            <span className="dash-stock-vol">{stageValue(s)}</span>
          </div>
        ))}
      </div>

      <div className="dash-stocks-total">
        <span className="dash-stocks-total-label">
          <Tooltip title={TOTAL_HINT}>
            <span className="dash-info-dot">i</span>
          </Tooltip>
          Загальна кількість сухої та сирої деревини
        </span>
        <span style={{ fontWeight: 700, fontSize: 15, fontVariantNumeric: 'tabular-nums' }}>
          {total.toLocaleString('uk-UA', { minimumFractionDigits: 1, maximumFractionDigits: 1 })}{' '}
          <span style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)' }}>м³</span>
        </span>
      </div>
    </div>
  );
}
